import { useRecordContext, useTranslate } from "ra-core";
import { HeartPulse, Cake, MessageSquareText } from "lucide-react";
import type { ReactNode } from "react";
import type { Contact } from "../types";
import { ageFromDateOfBirth } from "./playerAge";

/** What a coach needs to know about a child, shown on the person page. */
export const ChampPlayerInfo = () => {
  const record = useRecordContext<Contact>();
  const translate = useTranslate();
  if (!record || record.role !== "player") return null;

  const age = ageFromDateOfBirth(record.date_of_birth);
  return (
    <div className="flex flex-col gap-2">
      {record.date_of_birth && (
        <Row icon={<Cake className="w-4 h-4 text-muted-foreground" />}>
          {translate("resources.contacts.player_age", {
            smart_count: age ?? 0,
            date: record.date_of_birth,
          })}
        </Row>
      )}
      {record.medical_notes && (
        <Row icon={<HeartPulse className="w-4 h-4 text-destructive" />}>
          <span className="font-medium text-destructive">
            {record.medical_notes}
          </span>
        </Row>
      )}
      {record.coach_notes && (
        <Row
          icon={<MessageSquareText className="w-4 h-4 text-muted-foreground" />}
        >
          {record.coach_notes}
        </Row>
      )}
    </div>
  );
};

const Row = ({ icon, children }: { icon: ReactNode; children: ReactNode }) => (
  <div className="flex items-start gap-2">
    <span className="mt-0.5">{icon}</span>
    <span className="whitespace-pre-line">{children}</span>
  </div>
);
